(function () {
  'use strict';

  var queue = [];
  var running = false;
  var lightDone = false;
  var heavyDone = false;
  var commerceDisplayDone = false;
  var analyticsDone = false;
  var socialDone = false;
  var formsDone = false;

  function isCommerceDisplayScript(url) {
    if (!url) return false;
    if (/bss-b2b/i.test(url)) return true;
    if (/paypalobjects\.com\/pa\/js/i.test(url)) return true;
    if (/paypal\.com\/sdk\/js/i.test(url) && /components=messages/i.test(url)) return true;
    if (/pay-later-messaging|smart-credit-message/i.test(url)) return true;
    return false;
  }

  function collectScripts() {
    return Array.prototype.slice.call(
      document.querySelectorAll(
        'script[data-src]:not([data-mt-activated]), script[type="text/mt-deferred"][data-src]:not([data-mt-activated])'
      )
    );
  }

  function tierFor(node) {
    var url = node.getAttribute('data-src') || '';
    /* Shopify analytics — soft-defer for LCP/TBT; restore a few seconds after load */
    if (
      url.indexOf('/cdn/wpm/') !== -1 ||
      url.indexOf('/wpm/') !== -1 ||
      url.indexOf('trekkie.storefront') !== -1 ||
      url.indexOf('shop_events_listener') !== -1 ||
      url.indexOf('web-pixels') !== -1
    ) {
      return 'analytics';
    }
    /* Meta Pixel — after LCP window, not cart-only (ads still fire; not on critical path) */
    if (
      url.indexOf('fbevents') !== -1 ||
      url.indexOf('facebook.net') !== -1 ||
      url.indexOf('facebook.com/tr') !== -1
    ) {
      return 'analytics';
    }
    /* Instagram / Social Widget — activate near section, not on first paint */
    if (
      url.indexOf('social-widget') !== -1 ||
      url.indexOf('nfcube') !== -1 ||
      url.indexOf('instafeed') !== -1 ||
      url.indexOf('widget_v3') !== -1 ||
      url.indexOf('onecommerce') !== -1
    ) {
      return 'social';
    }
    /* Shopify Forms + hCaptcha — only when popups/forms are needed */
    if (
      url.indexOf('hcaptcha') !== -1 ||
      url.indexOf('forms-web') !== -1 ||
      url.indexOf('shopify-forms') !== -1 ||
      url.indexOf('forms-2477') !== -1
    ) {
      return 'forms';
    }
    if (isCommerceDisplayScript(url)) return 'commerce';
    if (url.indexOf('kbite-back-in-stock') !== -1) return 'heavy';
    if (url.indexOf('privacy-banner') !== -1) return 'heavy';
    if (url.indexOf('storefront-banner') !== -1) return 'heavy';
    if (url.indexOf('cartbite') !== -1) return 'heavy';
    if (url.indexOf('judgeme') !== -1 || url.indexOf('judge.me') !== -1) return 'heavy';
    if (/paypal/i.test(url)) return 'heavy';
    if (url.indexOf('klaviyo') !== -1) return 'heavy';
    if (url.indexOf('product-fees') !== -1 || url.indexOf('advanced-shipping') !== -1) return 'heavy';
    if (url.indexOf('shopify_pay') !== -1 || url.indexOf('perf-kit') !== -1) return 'heavy';
    if (url.indexOf('shop.app') !== -1 || url.indexOf('preloads.js') !== -1) return 'heavy';
    if (url.indexOf('portable-wallets') !== -1 || url.indexOf('init-shop-cart-sync') !== -1) return 'heavy';
    if (url.indexOf('webmcp') !== -1 || url.indexOf('standard-actions') !== -1) return 'heavy';
    if (url.indexOf('shop-js') !== -1 || url.indexOf('customer-account') !== -1) return 'heavy';
    if (/checkout-[A-Za-z0-9._-]+\.js/i.test(url) || /Authorize/i.test(url) || /AutoSubmitForm/i.test(url)) {
      return 'heavy';
    }
    if (url.indexOf('accounts.shopify.com') !== -1 || url.indexOf('shopifycloud/identity') !== -1) {
      return 'heavy';
    }
    if (url.indexOf('staq-cdn') !== -1 || url.indexOf('staqlab') !== -1 || url.indexOf('grow/api') !== -1) return 'heavy';
    if (url.indexOf('compiled_assets/scripts') !== -1) return 'heavy';
    /* Redundant Admin gtag/gtm duplicates — never during LCP; ultra-late only */
    if (url.indexOf('googletagmanager.com') !== -1 || url.indexOf('googleadservices') !== -1) {
      return 'heavy';
    }
    return 'light';
  }

  function copyScriptDataAttrs(from, to) {
    if (!from || !to || !from.attributes) return;
    for (var i = 0; i < from.attributes.length; i++) {
      var attr = from.attributes[i];
      var name = attr.name;
      if (name === 'src' || name === 'data-src' || name === 'type' || name === 'data-mt-gated' || name === 'data-mt-activated' || name === 'data-mt-module') {
        continue;
      }
      if (name.indexOf('data-') === 0) {
        try {
          to.setAttribute(name, attr.value);
        } catch (eAttr) {}
      }
    }
  }

  function activateScript(node) {
    if (!node || node.getAttribute('data-mt-activated') === '1') return;
    var url = node.getAttribute('data-src');
    if (!url) return;

    node.setAttribute('data-mt-activated', '1');
    var script = document.createElement('script');
    /* Bypass mt-script-gate src interceptor so intentional activates actually fetch */
    script.setAttribute('data-mt-allow', '1');
    copyScriptDataAttrs(node, script);
    var isPaypalMessages = /paypal\.com\/sdk\/js/i.test(url) && /components=messages/i.test(url);
    if (isPaypalMessages && !script.getAttribute('data-namespace')) {
      script.setAttribute('data-namespace', 'PayPalSDK');
    }
    if (node.getAttribute('data-mt-module') === '1') {
      script.type = 'module';
    } else {
      script.type = 'text/javascript';
      if (!isPaypalMessages) {
        script.async = true;
        script.defer = true;
      }
    }
    if (node.getAttribute('crossorigin') != null || /shop\.app|shopifycloud/i.test(url)) {
      script.crossOrigin = 'anonymous';
    }
    script.src = url;
    if (node.parentNode) {
      node.parentNode.insertBefore(script, node);
    } else {
      document.head.appendChild(script);
    }
  }

  var queueFast = false;

  function runQueue() {
    if (running || !queue.length) return;
    running = true;

    function next() {
      if (!queue.length) {
        running = false;
        queueFast = false;
        return;
      }
      activateScript(queue.shift());
      /*
        Heavy app bundles: long stagger (TBT).
        Social-only: short stagger so the Instagram grid paints quickly once unlocked.
      */
      var delay = queueFast ? 100 : 900;
      var idleTimeout = queueFast ? 300 : delay;
      if ('requestIdleCallback' in window) {
        requestIdleCallback(
          function () {
            setTimeout(next, queueFast ? 50 : 200);
          },
          { timeout: idleTimeout }
        );
      } else {
        setTimeout(next, delay);
      }
    }

    next();
  }

  function enqueueTier(tiers, opts) {
    if (typeof window.__mtScriptGateScan === 'function') {
      window.__mtScriptGateScan();
    }
    if (opts && opts.fast) queueFast = true;
    collectScripts()
      .filter(function (node) {
        return tiers.indexOf(tierFor(node)) !== -1;
      })
      .forEach(function (node) {
        queue.push(node);
      });
    runQueue();
  }

  function activateSocial() {
    if (socialDone) return;
    socialDone = true;
    enqueueTier(['social'], { fast: true });
  }

  function activateForms() {
    if (formsDone) return;
    formsDone = true;
    enqueueTier(['forms'], { fast: true });
  }

  function activateLight() {
    if (lightDone) return;
    lightDone = true;
    enqueueTier(['light']);
  }

  function activateAnalytics() {
    if (analyticsDone) return;
    analyticsDone = true;
    if (typeof window.__mtWarmThirdPartyOrigins === 'function') {
      try {
        window.__mtWarmThirdPartyOrigins();
      } catch (eW) {}
    }
    enqueueTier(['analytics']);
  }

  function activateShopJsInline() {
    var nodes = document.querySelectorAll('script[type="text/mt-deferred-shopjs"]');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (!node || node.getAttribute('data-mt-activated') === '1') continue;
      node.setAttribute('data-mt-activated', '1');
      var script = document.createElement('script');
      script.type = 'module';
      script.textContent = node.textContent;
      if (node.parentNode) {
        node.parentNode.insertBefore(script, node);
      } else {
        document.head.appendChild(script);
      }
    }
  }

  function activateJudgeme() {
    var nodes = collectScripts();
    for (var i = 0; i < nodes.length; i++) {
      var url = nodes[i].getAttribute('data-src') || '';
      if (/judgeme|judge\.me/i.test(url)) activateScript(nodes[i]);
    }
    var links = document.querySelectorAll('link[data-mt-css-gated="1"][href]');
    for (var j = 0; j < links.length; j++) {
      var href = links[j].getAttribute('href') || '';
      if (/judgeme|judge\.me/i.test(href)) links[j].media = 'all';
    }
  }

  function activateCommerceDisplay() {
    if (commerceDisplayDone) return;
    commerceDisplayDone = true;
    enqueueTier(['commerce'], { fast: true });
    /* Product-page stars + write-a-review must not wait for cart-intent heavy. */
    if (document.body && document.body.classList.contains('page-product')) {
      activateJudgeme();
    }
  }

  function pageNeedsCommerceDisplay() {
    return !!document.querySelector(
      '[bss-b2b-product-price], [bss-b2b-variant-price], #product-paypal-messaging, #cart-paypal-messaging, #cart-drawer-paypal-messaging, .product__paypal-messaging, .product__judgeme-badge, .jdgm-preview-badge, #mt-judgeme-reviews'
    );
  }

  function activateHeavy() {
    if (heavyDone) return;
    heavyDone = true;
    window.__mtHeavyAppsReady = true;
    activateCommerceDisplay();
    if (typeof window.__mtWarmThirdPartyOrigins === 'function') {
      try {
        window.__mtWarmThirdPartyOrigins();
      } catch (eW2) {}
    }
    activateLight();
    activateShopJsInline();
    if (typeof window.__mtRunPaymentButtonInit === 'function') {
      try {
        window.__mtRunPaymentButtonInit();
      } catch (ePbRun) {}
    } else if (
      window.Shopify &&
      Shopify.PaymentButton &&
      typeof Shopify.PaymentButton.__mtRealInit === 'function'
    ) {
      try {
        Shopify.PaymentButton.__mtRealInit.call(Shopify.PaymentButton);
      } catch (ePbReal) {}
    }
    enqueueTier(['heavy']);
    if (typeof window.__mtScriptGateDisconnect === 'function') {
      window.__mtScriptGateDisconnect();
    }
  }

  /**
   * Buy now: load BSS only, immediately.
   * Do not use activateHeavy() on Buy now — heavy staggers PayPal/Judge.me/etc.
   * ~900ms apart and can stall the click for tens of seconds.
   */
  function activateBssForCheckout() {
    if (
      window.BSS_B2B &&
      window.BSS_B2B.observer &&
      window.BSS_B2B.observer.cartSubject &&
      typeof window.BSS_B2B.observer.cartSubject.notifyObserver === 'function'
    ) {
      return Promise.resolve(true);
    }
    if (typeof window.__mtScriptGateScan === 'function') {
      try {
        window.__mtScriptGateScan();
      } catch (eScan) {}
    }
    collectScripts()
      .filter(function (node) {
        var url = node.getAttribute('data-src') || '';
        return url.indexOf('bss-b2b-') !== -1 || url.indexOf('bss_b2b') !== -1;
      })
      .forEach(function (node) {
        activateScript(node);
      });
    return new Promise(function (resolve) {
      var started = Date.now();
      (function poll() {
        if (
          window.BSS_B2B &&
          window.BSS_B2B.observer &&
          window.BSS_B2B.observer.cartSubject &&
          typeof window.BSS_B2B.observer.cartSubject.notifyObserver === 'function'
        ) {
          resolve(true);
          return;
        }
        if (Date.now() - started > 1500) {
          resolve(false);
          return;
        }
        setTimeout(poll, 50);
      })();
    });
  }

  function activateAll() {
    activateAnalytics();
    activateLight();
    activateForms();
    activateSocial();
    activateHeavy();
  }

  function isCommerceTarget(target) {
    if (!target || !target.closest) return false;
    /* Cart chrome + Buy now — do NOT match general product forms (quick-add wraps
       cards; Lighthouse/product clicks would unlock PayPal/BSS and spike TBT).
       [data-buy-now] must unlock heavy so BSS can write partner discounts before checkout. */
    return !!target.closest(
      'cart-drawer, cart-notification, .cart-drawer, .header__icon--cart, #cart-icon-bubble, a[href="/cart"], a[href$="/cart"], [data-buy-now], .product-form__buy-now'
    );
  }

  /*
    Activating a tier is a long task (~440ms on a 4x-throttled phone). Run it straight
    from the pointerdown handler and it lands on whatever that same tap just opened:
    the menu drawer's 200ms slide-in was swallowed whole, so the first open snapped
    into place while every later open animated. Let the tapped UI finish first — the
    tier still unlocks on this interaction, just after the frames the user watches.
    Covers the menu drawer (200ms) and cart drawer (~300ms) transitions.
  */
  var UI_SETTLE_MS = 450;
  var lightScheduled = false;
  var heavyScheduled = false;

  function scheduleLightTiers() {
    if (lightScheduled) return;
    lightScheduled = true;
    setTimeout(function () {
      activateAnalytics();
      activateLight();
      /* Forms/hCaptcha: NOT here — Lighthouse synthetic clicks were unlocking ~800KiB captcha.
         Popups call __mtActivateFormsTier; late safety net below. */
    }, UI_SETTLE_MS);
  }

  function scheduleHeavyTier() {
    if (heavyScheduled) return;
    heavyScheduled = true;
    setTimeout(activateHeavy, UI_SETTLE_MS);
  }

  function onPointerIntent(event) {
    scheduleLightTiers();
    if (isCommerceTarget(event.target)) scheduleHeavyTier();
  }

  function onKeyIntent(event) {
    scheduleLightTiers();
    if (event.key === 'Enter' || event.key === ' ') {
      if (isCommerceTarget(event.target)) scheduleHeavyTier();
    }
  }

  if (window.Shopify && Shopify.designMode) {
    activateAll();
    return;
  }

  /* Light apps: any intent. Heavy (PayPal/Shop Pay/BSS/etc.): cart/checkout only.
     Prevents Lighthouse synthetic focus/input from unlocking the heavy tier. */
  document.addEventListener('pointerdown', onPointerIntent, { passive: true });
  document.addEventListener('touchstart', onPointerIntent, { passive: true });
  document.addEventListener('keydown', onKeyIntent, { passive: true });

  /*
    Social Widget: never compete with hero LCP.

    Regression (80→71 / LCP 4.6→7.6 / IG 0→1513 KiB): buffered LCP PO fired on an
    early candidate, then idleWarm (timeout 4s) + IO rootMargin 1600px activated
    social ~1s in — IG masters downloaded during the hero window. The prior 0 KiB
    lab result was volatile (widget missed the gather window), not durable deferral.

    Durable rule (no UX change for scrollers):
    - Require window `load` + short settle before any social activate
    - Real users: scrollY>480 or near-viewport (200px), after that gate
    - No short idle warm (that re-entered the LH network window)
    - Late safety: load+12s (after typical lab gather; still fills grid for non-scrollers)
  */
  var socialGateOpen = false;
  function openSocialGate() {
    socialGateOpen = true;
  }
  window.addEventListener(
    'load',
    function () {
      /* Hero LCP usually finalizes shortly after load; keep social off that race. */
      setTimeout(openSocialGate, 1500);
    },
    { once: true }
  );

  function activateSocialWhenReady() {
    if (!socialGateOpen) {
      setTimeout(activateSocialWhenReady, 200);
      return;
    }
    activateSocial();
  }

  function watchSocial() {
    /* Real users scrolling toward the grid — Lighthouse does not scroll */
    window.addEventListener(
      'scroll',
      function onSocialScroll() {
        if (window.scrollY < 480) return;
        window.removeEventListener('scroll', onSocialScroll);
        activateSocialWhenReady();
      },
      { passive: true }
    );

    /* Near-viewport only (200px) — 1600px was effectively "already on screen" on mobile home */
    function observeMount(el) {
      if (!el || !('IntersectionObserver' in window)) return;
      var target = el.closest('.shopify-section') || el.closest('.shopify-block') || el;
      var io = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              io.disconnect();
              activateSocialWhenReady();
              break;
            }
          }
        },
        { rootMargin: '200px 0px' }
      );
      io.observe(target);
    }
    observeMount(document.querySelector('.social-widget-wrapper'));
    observeMount(document.getElementById('shopify-section-1770895753d6392705'));

    window.addEventListener(
      'load',
      function () {
        setTimeout(activateSocialWhenReady, 12000);
      },
      { once: true }
    );
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchSocial, { once: true });
  } else {
    watchSocial();
  }

  /* Scroll unlocks light apps only after meaningful depth — keeps PSI main thread clear */
  window.addEventListener(
    'scroll',
    function () {
      if (window.scrollY > 1200) activateLight();
    },
    { once: true, passive: true }
  );

  window.addEventListener(
    'load',
    function () {
      /* Analytics (Meta Pixel etc.): well after Lighthouse’s LCP window */
      setTimeout(activateAnalytics, 90000);
      setTimeout(activateLight, 90000);
      /* Forms/hCaptcha: only if popup never opened */
      setTimeout(activateForms, 60000);
      /* Heavy (PayPal checkout / Shop Pay / cart apps): cart intent; ultra-late safety net */
      setTimeout(activateHeavy, 180000);
    },
    { once: true }
  );

  /*
    PDP Judge.me: activate on DOMContentLoaded (after mt-script-gate neuters loader.js).
    Do NOT run at defer-script time (document.readyState === 'interactive') — gate scan
    has not run yet so collectScripts() finds no data-src placeholders.
    Fallback: load+400ms via activateCommerceDisplay (BSS/PayPal path).
  */
  function scheduleEarlyJudgemeOnProductPage() {
    function run() {
      if (!document.body || !document.body.classList.contains('page-product')) return;
      if (typeof window.__mtScriptGateScan === 'function') {
        window.__mtScriptGateScan();
      }
      activateJudgeme();
    }
    if (document.readyState === 'complete') {
      run();
    } else {
      document.addEventListener('DOMContentLoaded', run, { once: true });
    }
  }
  scheduleEarlyJudgemeOnProductPage();

  /*
    Guest retail prices + PayPal Pay Later messaging on PDP/collection/search.
    BSS hides [bss-b2b-product-price] until JS runs; mt-script-gate defers BSS until cart
    click. PayPal Messages SDK is no longer gated (needs data-namespace=PayPalSDK).
    BSS still hydrates after first paint so wholesale JS is not on LCP.
  */
  if (pageNeedsCommerceDisplay()) {
    if (document.readyState === 'complete') {
      setTimeout(activateCommerceDisplay, 400);
    } else {
      window.addEventListener(
        'load',
        function () {
          setTimeout(activateCommerceDisplay, 400);
        },
        { once: true }
      );
    }
  }

  window.__mtActivateFormsTier = activateForms;
  window.__mtActivateCommerceDisplay = activateCommerceDisplay;
  window.__mtActivateJudgeme = activateJudgeme;
  /* Full heavy unlock (PayPal/BSS/etc.) — cart chrome intent only. */
  window.__mtActivateHeavyTier = activateHeavy;
  /* Buy now: BSS scripts only (avoids ~900ms heavy-tier stagger). */
  window.__mtActivateBssForCheckout = activateBssForCheckout;
})();
